import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { BlockModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'
import { formatDateTimesInText } from '../../utils/dateUtils'

export function useBlock() {
  const { t, i18n } = useTranslation('exceptions')
  const { authInfo } = useAuth()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const block = async (courtId: number, blockId: number) => {
    setLoading(true)

    try {
      const data = await fetcher<BlockModel>(
        `${CONFIG.BOUNCE_API}/api/v1/courts/${courtId}/blocks/${blockId}`
      )

      if (data) {
        setError(null)
        return {
          ...data,
          courtId,
        }
      }
    } catch (error) {
      console.log(error)

      if (error instanceof ApiError) {
        setError(
          formatDateTimesInText(getErrorMessage(error.data), i18n.language)
        )
      } else {
        setError(t('exceptions:unknown'))
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    block,
    loading,
    error,
    resetState,
  }
}
